<template functional>
  <a-menu-item v-if="!props.menu.children || props.menu.children.length === 0" :key="`menu-item-${props.menu.id}`">
    <router-link :to="props.menu.link" :target="props.menu.target === 2 ? '_blank' : ''">
      <i
        v-if="props.menu.icon"
        :class="['iconfont-gxxf', `icon-gxxf-${props.menu.icon}`]"
        style="margin-right: 10px"
      ></i>
      <span v-html="props.menu.text"></span>
    </router-link>
  </a-menu-item>
  <a-sub-menu v-else :key="`submenu-${props.menu.id}`">
    <template slot="title">
      <i
        v-if="props.menu.icon"
        :class="['iconfont-gxxf', `icon-gxxf-${props.menu.icon}`]"
        style="margin-right: 10px"
      ></i>
      <span v-html="props.menu.text"></span>
    </template>
    <template v-for="item in props.menu.children">
      <a-menu-item v-if="!item.children || item.children.length === 0" :key="`menu-item-${item.id}`">
        <router-link :to="item.link" :target="item.target === 2 ? '_blank' : ''">
          <i v-if="item.icon" :class="['iconfont-gxxf', `icon-gxxf-${item.icon}`]" style="margin-right: 10px"></i>
          <span v-html="item.text"></span>
        </router-link>
      </a-menu-item>
      <sub-menu v-else :key="`submenu-${item.id}`" :menu="item" />
    </template>
  </a-sub-menu>
</template>
<script>
export default {
  props: ['menu'],
}
</script>
